import { createAuthClient } from 'better-auth/react';

/**
 * Same origin in both setups: in production the Worker serves the app and /api, and in local dev
 * Vite proxies /api to `wrangler dev` on :8787 (vite.config.ts). The Worker's TRUSTED_ORIGINS
 * includes http://localhost:5173 so Better Auth accepts the dev server's Origin header.
 */
export const authClient = createAuthClient({
  baseURL: typeof window !== 'undefined' ? window.location.origin : 'http://localhost',
  basePath: '/api/auth',
});
